const territorial = [
    { id: 1, description: "Alt Camp", url: "alt-camp" },
    { id: 2, description: "Alt Empordà", url: "alt-emporda" },
    { id: 3, description: "Alt Penedès", url: "alt-penedes" },
    { id: 4, description: "Alt Urgell", url: "alt-urgell" },
    { id: 5, description: "Alta Ribagorça", url: "alta-ribagorça" },
    { id: 6, description: "Anoia", url: "anoia" },
    { id: 39, description: "Aran", url: "aran" },
    { id: 7, description: "Bages", url: "bages" },
    { id: 8, description: "Baix Camp", url: "baix-camp" },
    { id: 9, description: "Baix Ebre", url: "baix-ebre" },
    { id: 10, description: "Baix Empordà", url: "baix-emporda" },
    { id: 11, description: "Baix Llobregat", url: "baix-llobregat" },
    { id: 12, description: "Baix Penedès", url: "baix-penedes" },
    { id: 13, description: "Barcelonès", url: "barcelones" },
    { id: 14, description: "Berguedà", url: "bergueda" },
    { id: 15, description: "Cerdanya", url: "cerdanya" },
    { id: 16, description: "Conca de Barberà", url: "conca-de-barbera" },
    { id: 17, description: "Garraf", url: "garraf" },
    { id: 18, description: "Garrigues", url: "garrigues" },
    { id: 19, description: "Garrotxa", url: "garrotxa" },
    { id: 20, description: "Gironès", url: "girones" },
    { id: 21, description: "Maresme", url: "maresme" },
    { id: 42, description: "Moianès", url: "moianes" },
    { id: 22, description: "Montsià", url: "montsia" },
    { id: 23, description: "Noguera", url: "noguera" },
    { id: 24, description: "Osona", url: "osona" },
    { id: 25, description: "Pallars Jussà", url: "pallars-jussa" },
    { id: 26, description: "Pallars Sobirà", url: "pallars-sobira" },
    { id: 27, description: "Pla d'Urgell", url: "pla-durgell" },
    { id: 28, description: "Pla de l'Estany", url: "pla-de-lestany" },
    { id: 29, description: "Priorat", url: "priorat" },
    { id: 30, description: "Ribera d'Ebre", url: "ribera-debre" },
    { id: 31, description: "Ripollès", url: "ripolles" },
    { id: 32, description: "Segarra", url: "segarra" },
    { id: 33, description: "Segrià", url: "segria" },
    { id: 34, description: "Selva", url: "selva" },
    { id: 35, description: "Solsonès", url: "solsones" },
    { id: 36, description: "Tarragonès", url: "tarragones" },
    { id: 37, description: "Terra Alta", url: "terra-alta" },
    { id: 38, description: "Urgell", url: "urgell" },
    { id: 40, description: "Vallès Occidental", url: "valles-occidental" },
    { id: 41, description: "Vallès Oriental", url: "valles-oriental" },
]

export { territorial }


// WEBPACK FOOTER //
// ./src/services/territorial.service.js